import React, { useEffect, useRef } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { deferStampDataTestIdOnDescendantRef, toTestIdSlug } from '@utils/testUtils';

export type NotifyOfTransportOption = {
  contactName?: string | null;
  contactEmail?: string | null;
};

interface ComponentProps {
  options?: NotifyOfTransportOption[];
  value?: NotifyOfTransportOption[];
  onChange: (value: NotifyOfTransportOption[]) => void;
  dataTestId?: string;
}

const NotifyOfTransportMultiSelect: React.FC<ComponentProps> = ({ options, value, onChange, dataTestId }) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    return deferStampDataTestIdOnDescendantRef(wrapperRef, '.p-multiselect', dataTestId);
  }, [dataTestId]);

  return (
    <div ref={wrapperRef} className="w-full">
      <MultiSelect
        className="w-full"
        options={options}
        optionLabel={'contactName'}
        dataKey={'contactEmail'}
        value={value}
        onChange={e => onChange(e.value)}
        filter
        itemTemplate={(option: NotifyOfTransportOption) => {
          const displayedValue = option?.contactName ?? option?.contactEmail ?? '';
          const slug = toTestIdSlug(displayedValue) || toTestIdSlug(option?.contactEmail) || 'unknown';
          const optionTestId = dataTestId ? `${dataTestId}-${slug}` : undefined;

          return <span data-testid={optionTestId}>{displayedValue}</span>;
        }}
      />
    </div>
  );
};

export default NotifyOfTransportMultiSelect;